export default __webpack_public_path__ + "static/media/logo.09cebba0.svg";